import type { ReactNode } from 'react';
import { useHomeInViewSection } from './useHomeInViewSection';

type HomeLazySectionProps = Readonly<{
  id?: string;
  className?: string;
  lazy?: boolean;
  placeholderMinHeight?: string;
  children: ReactNode | ((state: { mounted: boolean; inView: boolean }) => ReactNode);
}>;

/**
 * Below-fold section shell — `content-visibility` + optional lazy mount.
 */
export function HomeLazySection({
  id,
  className = '',
  lazy = true,
  placeholderMinHeight = '12rem',
  children,
}: HomeLazySectionProps) {
  const { sectionRef, inView, mounted } = useHomeInViewSection({ lazy });

  const content =
    typeof children === 'function' ? children({ mounted, inView }) : children;

  return (
    <section
      id={id}
      ref={sectionRef}
      className={`home-below-fold-section home-lazy-section ${className}`}
      style={{ contentVisibility: 'auto', containIntrinsicSize: `auto ${placeholderMinHeight}` }}
    >
      {mounted ? content : <div aria-hidden style={{ minHeight: placeholderMinHeight }} />}
    </section>
  );
}
